import { DateTime } from 'luxon'
import { DateTimePipe } from '../../shared/pipes/date-time.pipe'
import { ElementChoice } from '@app/features/shared/components/element-choice-select/element-choice'

export class TimeElementChoice implements  ElementChoice<Date> {

    constructor(
        private date: Date,
        private timeZone: string,
        private datePipe: DateTimePipe
    ) { }

    get id(): string {
        return this.date.toISOString()
    }

    get displayName(): string {
        return this.datePipe.transform(this.date, this.timeZone, DateTime.TIME_24_SIMPLE) ?? ''
    }

    get value(): Date {
        return this.date
    }
}
